var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('image-asset-embed');
import { ImageAsset } from './image-asset';
import { breakpoints, theme } from '@shapeable/theme';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useLink } from '../../hooks/use-link';
import { pickBy } from 'lodash';
export var ImageAssetEmbedDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    object-fit: contain;\n\n    ", "\n\n    ", "\n\n  "], ["\n    margin-bottom: ", ";\n    object-fit: contain;\n\n    ", "\n\n    ", "\n\n  "])), theme.UNIT(4), function (_a) {
    var nomargin = _a.nomargin;
    return nomargin && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  }, function (_a) {
    var width = _a.width;
    return width && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), width);
  }),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = breakpoints({
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 50%;\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    width: 50%;\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(8))
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    \n    ", "\n\n  "], ["\n    margin-bottom: ", ";\n    \n    ", "\n\n  "])), theme.UNIT(4), function (_a) {
    var nomargin = _a.nomargin;
    return nomargin && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  }),
  desktop: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasChildren = _a.hasChildren;
    return hasChildren && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Zoom: styled(Zoom)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  ImageContainer: styled.div.attrs(cls.attr('image-container'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Image: styled(ImageAsset)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var ImageAssetEmbed = function ImageAssetEmbed(props) {
  var className = props.className,
      entity = props.entity,
      children = props.children,
      width = props.width,
      nomargin = props.nomargin,
      nozoom = props.nozoom,
      href = props.href,
      alt = props.alt,
      longdesc = props.longdesc,
      title = props.title;

  if (process.env.DEBUG_EMBED_PROPS) {
    console.log("IMAGE ASSET EMBED PROPS", props);
  }

  var Link = useLink().Link;
  var imgProps = pickBy({
    alt: alt,
    longdesc: longdesc,
    title: title
  });
  var hasChildren = !!children;
  var ImageContainer = nozoom || !!href ? My.ImageContainer : My.Zoom;
  var inner = React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(ImageContainer, {
    nomargin: nomargin
  }, React.createElement(My.Image, __assign({
    nomargin: nomargin,
    width: width
  }, imgProps, {
    entity: entity
  }))), hasChildren && React.createElement(My.Content, null, children));
  return href ? React.createElement(Link, {
    href: href,
    target: "_blank"
  }, inner) : inner;
};
ImageAssetEmbed.defaultProps = ImageAssetEmbedDefaultProps;
ImageAssetEmbed.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;